import { useCallback } from 'react';

import { APP_PRODUCT_TYPE, LOCAL_KEY_ACCOUNT_REP } from 'appConstants';
import { ACCOUNT_REPRESENTATIVES_DEFAULT_VALUES } from 'appConstants';
import { AccountRepresentatives } from 'components';
import { useField } from 'formik';
import { useLocalStorage } from 'hooks/useLocalStorage';

import type { IAccountRepresentativesField } from './types';

export default function AccountRepresentativesField({
  name,
  disabled,
  textFieldProps,
  productType = APP_PRODUCT_TYPE.FERTILISER,
}: IAccountRepresentativesField) {
  const [{ value }, , { setValue }] = useField(name);
  const [, metaId, { setTouched }] = useField(`${name}.representativeCode`);
  const [, updateDefaultAccountRep] = useLocalStorage(
    `${LOCAL_KEY_ACCOUNT_REP}${productType !== APP_PRODUCT_TYPE.FERTILISER ? productType : ''}`,
    true,
  );

  const hasError = Boolean(metaId.touched && metaId.error);
  const helperText = hasError ? metaId.error : '';

  const handleOnBlur = useCallback(async () => {
    if (!metaId.touched) await setTouched(true, false);
  }, [setTouched, metaId.touched]);

  const handleOnChange = useCallback(
    async (option) => {
      await setValue(option || ACCOUNT_REPRESENTATIVES_DEFAULT_VALUES, true);
      if (option) updateDefaultAccountRep(option);
    },
    [setValue, updateDefaultAccountRep],
  );

  return (
    <AccountRepresentatives
      data-testid={`${name}-field`}
      disabled={disabled}
      textFieldProps={{
        name: name,
        error: hasError,
        helperText: helperText,
        onBlur: handleOnBlur,
        ...textFieldProps,
      }}
      selectedAccount={value && value.representativeCode ? value : null}
      onChange={handleOnChange}
      productType={productType}
    />
  );
}
